import {Descriptions, Drawer} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import {TableData} from '../../../../../CommonComponents/TableData';

const medicineColumns = [
  {title: 'Medicine', dataIndex: 'medicineName'},
  {title: 'Dosage', dataIndex: 'dosage'},
  {title: 'Frequency', dataIndex: 'frequency'},
  {title: 'Duration', dataIndex: 'duration'},
  {title: 'Before/After Food', dataIndex: 'beforeAfterFood', render: v => v || '-'},
  {title: 'Instructions', dataIndex: 'instructions', render: v => v || '-'},
  {title: 'Quantity', dataIndex: 'quantity'},
  {title: 'Route', dataIndex: 'route'},
];

const panchakarmaColumns = [
  {title: 'Therapy', dataIndex: 'therapyName'},
  {title: 'Days', dataIndex: 'numberOfDays'},
  {title: 'Session Time', dataIndex: 'sessionTime'},
  {title: 'Instructions', dataIndex: 'instructions'},
];

const dietColumns = [
  {title: 'Meal', dataIndex: 'mealType'},
  {title: 'Recommended', dataIndex: 'recommendedFood'},
  {title: 'Avoid', dataIndex: 'avoidFood'},
  {title: 'Advice', dataIndex: 'advice'},
];

const PrescriptionDetailsDrawer = ({open, prescription, patientLabelById, onClose}) => (
  <Drawer
    title={(
      <span className={'text-primary-700 font-bold text-base'}>
        {`Prescription Details — ${patientLabelById[prescription?.patientId] || prescription?.patientId || ''}`}
      </span>
    )}
    open={open}
    onClose={onClose}
    width={760}
    destroyOnHidden
  >
    {prescription && (
      <>
        <Descriptions column={2} bordered size={'small'} className={'mb-6'}>
          <Descriptions.Item label={'Patient'}>
            {patientLabelById[prescription.patientId] || prescription.patientId}
          </Descriptions.Item>
          <Descriptions.Item label={'Created Date'}>
            {prescription.createdDate}
          </Descriptions.Item>
          <Descriptions.Item label={'Doctor Notes'} span={2}>
            {prescription.doctorNotes || '-'}
          </Descriptions.Item>
        </Descriptions>

        <div className={'mb-6'}>
          <span className={'font-semibold text-gray-700 block mb-2'}>Medicines</span>
          <TableData
            dataSource={prescription.medicines ?? []}
            columns={medicineColumns}
            rowKey={(_, i) => i}
            pagination={false}
            size={'small'}
          />
        </div>

        <div className={'mb-6'}>
          <span className={'font-semibold text-gray-700 block mb-2'}>Panchakarma Advice</span>
          <TableData
            dataSource={prescription.panchakarmaAdvice ?? []}
            columns={panchakarmaColumns}
            rowKey={(_, i) => i}
            pagination={false}
            size={'small'}
          />
        </div>

        <div>
          <span className={'font-semibold text-gray-700 block mb-2'}>Diet Advice</span>
          <TableData
            dataSource={prescription.dietAdvice ?? []}
            columns={dietColumns}
            rowKey={(_, i) => i}
            pagination={false}
            size={'small'}
          />
        </div>
      </>
    )}
  </Drawer>
);
PrescriptionDetailsDrawer.propTypes = {
  open: PropTypes.bool,
  prescription: PropTypes.object,
  patientLabelById: PropTypes.object,
  onClose: PropTypes.func,
};

export default PrescriptionDetailsDrawer;
